import { FC, PropsWithChildren, useMemo } from "react";
import { CasinoScopesMap, isCasinoGameType } from "@finbackoffice/site-core";
import { useRouter } from "next/router";
import { CasinoGameTypeEnum } from "@finbackoffice/fe-core";
import Footer from "components/footer/Footer";
import { CasinoToolsProvider } from "contexts";
import ScrollComponent from "components/base/scroll/ScrollComponent";
import styles from "../../styles/casino-compact-layout.module.sass";
import SlotsCompactHeader from "./header/SlotsCompactHeader";
import SlotsTools from "./tools/SlotsTools";

const SlotsCompactLayout: FC<PropsWithChildren> = ({ children }) => {
    const router = useRouter();
    const isCasinoGameTypeMemo = useMemo(
        () => isCasinoGameType(router.query.filter as CasinoGameTypeEnum),
        [router.query.filter],
    );
    const initialGameTypes = useMemo(() => {
        if (isCasinoGameTypeMemo) {
            return [router.query.filter as CasinoGameTypeEnum];
        }

        return CasinoScopesMap.slots;
    }, [isCasinoGameTypeMemo, router.query.filter]);
    return (
        <CasinoToolsProvider initialGameTypes={initialGameTypes}>
            <ScrollComponent containerClass={styles.casinoScrollContainer} animateWithTopProperty>
                <div className={styles.casinoContainer}>
                    <SlotsCompactHeader />
                    <SlotsTools />
                    <div className={styles.casinoGamesContainer}>{children}</div>
                </div>
                <Footer />
            </ScrollComponent>
        </CasinoToolsProvider>
    );
};

export default SlotsCompactLayout;
